import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import MembershipSetup from "@/components/MembershipSetup";
import TaskTimeline from "@/components/TaskTimeline";

export default function TaskTimelinePage() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [equip, setEquip] = useState([]);
  const [orgTree, setOrgTree] = useState(null);
  const [orgMembers, setOrgMembers] = useState([]);
  const [unitMembers, setUnitMembers] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (!user?.company_id) return;
    api.get(`/equipment-config?company_id=${user.company_id}`).then((r) => setEquip(r.data.equipment || [])).catch(() => {});
    api.get(`/org/tree?company_id=${user.company_id}`).then((r) => setOrgTree(r.data)).catch(() => {});
    api.get(`/org/members?company_id=${user.company_id}`).then((r) => setOrgMembers(r.data.members || [])).catch(() => {});
    api.get("/org/unit-members").then((r) => setUnitMembers(r.data)).catch(() => {});
  }, [user]);

  const unitNameById = {}; const subNameById = {}; const teamNameById = {};
  for (const u of orgTree?.units || []) {
    unitNameById[u.id] = u.name;
    for (const s of u.subunits || []) { subNameById[s.id] = s.name; for (const tm of s.teams || []) teamNameById[tm.id] = tm.name; }
  }
  const orgLabelFor = (o) => [unitNameById[o?.unit_id], subNameById[o?.subunit_id], teamNameById[o?.team_id]].filter(Boolean).join(" / ") || "Unassigned";
  const orgByUser = {};
  if (orgMembers.length) {
    for (const m of orgMembers) orgByUser[m.id] = orgLabelFor(m.org);
  } else if (user?.org) {
    const own = orgLabelFor(user.org);
    orgByUser[user.id] = own;
    for (const m of unitMembers) orgByUser[m.id] = own;
  }
  const equipById = Object.fromEntries(equip.map((e) => [e.id, e]));

  const taskLabel = user?.terminology?.task_label || "Task";
  const tasksLabel = user?.terminology?.task_label_plural || "Tasks";

  if (!user?.company_id || !user?.role_id) {
    return <MembershipSetup title={`${taskLabel} Timeline`} message="To see your timeline, join a company and pick your crew role. One-time setup." />;
  }

  return (
    <div data-testid="task-timeline-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-num">Operations</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mt-1">{`${taskLabel} Timeline`}</h1>
        <p className="text-slate-400 mt-1 text-sm">
          Drag blocks to reschedule — they save automatically. Double-click a block to edit it on the {taskLabel} Planning page, or double-click empty space to build a new {taskLabel.toLowerCase()} there. Pop out a live window with the button on the right.
        </p>
      </div>

      <TaskTimeline userId={user?.id} companyId={user?.company_id} locationId={user?.location_id} refreshKey={refreshKey}
        onChanged={() => setRefreshKey((k) => k + 1)} tasksLabel={tasksLabel}
        groupData={{ orgByUser, equipById }}
        onEditTask={(t) => nav(`/tasks?edit=${t.id}`)}
        onQuickAdd={(d, hm) => nav(`/tasks?new=1&date=${d}&start=${hm}`)} />
    </div>
  );
}
